import {
  providerDetailUrl,
  type ProviderHrefBuilder,
} from "@appcaire/shared/seo";

/**
 * Origin of Hemtjänstguiden's provider profiles, used to build OUTBOUND absolute
 * URLs — today only the `/utforare` ItemList entries.
 *
 * This is not this site's canonical host, despite the name. Every page
 * nackahemtjanst.se serves self-canonicalises to nackahemtjanst.se: `/utforare`
 * via `publicListSeoState`, and `/anordnare/:slug` via its own
 * `CANONICAL_ORIGIN` in `ProviderPage.tsx` (pinned by `ProviderPage.test.tsx`).
 *
 * The previous comment here claimed "Local /anordnare routes set canonical to
 * this", describing a design the detail route no longer follows. Trusting it
 * shipped `/utforare` as index,follow pointing at another domain (#3277).
 */
export const NACKA_PROVIDER_CANONICAL_ORIGIN = "https://hemtjanstguide.se";

/**
 * Nacka list/search links use the local route.
 */
export const buildNackaProviderHref: ProviderHrefBuilder = (
  slug,
  municipalitySlug = "nacka",
) => providerDetailUrl(slug, municipalitySlug);
